import React, { PureComponent } from 'react';
import { Col } from "antd";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChartRenderer from "../components/ChartRenderer";
import Dashboard from "../components/Dashboard";
import DashboardItem from "../components/DashboardItem";
import { Multiselect } from 'multiselect-react-dropdown';
// import Tooltip from '@bit/recharts.recharts.tooltip';


class CustomerDashboardPage extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      options: [
        { name: 'ChampionX LLC.', value: 'ChampionX LLC.' },
        { name: 'Quality Carriers, Inc', value: 'Quality Carriers, Inc' },
        { name: 'Nalco Chemical Company', value: 'Nalco Chemical Company' },
        { name: 'B C GOODWIN TRANSPORTATION, LLC.', value: 'B C GOODWIN TRANSPORTATION, LLC.' },
        { name: 'Multi-Chem Group LLC', value: 'Multi-Chem Group LLC' },
        { name: 'Hazmat Environmental Group', value: 'Hazmat Environmental Group' }
      ],
      facilityList: ["Quality Carriers, Inc"],
      selectedValue: [ 
                      { name: 'Quality Carriers, Inc', value: 'Quality Carriers, Inc' }
                    ],
    };

    this.style = {
      chips: {
        background: "red"
      },
      searchBox: {
        border: "none",
        "border-bottom": "1px solid #001529",
        "border-radius": "0px"
      }
    };


  }


  onSelect = (selectedList, selectedItem) => {
    this.setState({
      facilityList: [...this.state.facilityList, selectedItem.value]
    }); 
     console.log('After Add', this.state.facilityList); 
  };

  onRemove = (selectedList, removedItem) => { 
    this.setState({
      facilityList: this.state.facilityList.filter(item => item !== removedItem.value)
    }); 
    console.log('After Remove', this.state.facilityList);
  };

  render() {
    const DashboardItems = [ 
     {
        id: 1,
        name: "Container Status",
        vizState: {
          query: {
            measures: ["ContainerStatus.count"],
            timeDimensions: [],
            order: {
              "ContainerStatus.count": "desc"
            },
            dimensions: ["ContainerStatus.container_status"],
            filters: [
              {
                dimension: "ContainerStatus.operated_by",
                operator: "contains",
                values: this.state.facilityList
              }
            ]
          },
          chartType: "pie"
        }
      },  {
        id: 0,
        name: "Arrival Age",
        vizState: {
          query: {
            "measures": [
              "ContainerStatus.count"
            ],
            "timeDimensions": [],
            "order": {
              "ContainerStatus.count": "desc"
            },
            "dimensions": [
              "ContainerStatus.arrival_age"
            ],
            "filters": [
              {
                "dimension": "ContainerStatus.operated_by",
                "operator": "equals",
                "values":this.state.facilityList
              }
            ]
          },
          chartType: "bar"
        }
      },
      {
        id: 2,
        name: "Arrival Age with Container Status",
        vizState: {
          query: {
            "measures": [
              "ContainerStatus.dirty_count",
              "ContainerStatus.clean_count"
            ],
            "timeDimensions": [
              {
                "dimension": "ContainerStatus.arrival_date"
              }
            ],
            "order": {
              "ContainerStatus.dirty_count": "desc"
            },
            "dimensions": [
              "ContainerStatus.arrival_age"
            ],
            "filters": [
              {
                "dimension": "ContainerStatus.operated_by",
                "operator": "equals",
                "values":this.state.facilityList
              }
            ]
          },
          chartType: "area"
        }
      }, {
        id: 3,
        name: "Facility wise containers with container status",
        vizState: {
          query: {
            measures: [
              "ContainerStatus.dirty_count",
              "ContainerStatus.clean_count"
            ],
            timeDimensions: [
              {
                dimension: "ContainerStatus.arrival_date"
              }
            ],
            order: {
              "ContainerStatus.dirty_count": "desc"
            },
            dimensions: [
              "ContainerStatus.location"
            ],
            filters: [
              {
                dimension: "ContainerStatus.operated_by",
                operator: "equals",
                values: this.state.facilityList
              }
            ]
          },
          chartType: "bar"
        }
      },{
        id: 4,
        name: "Current Status Age with Container Status",
        vizState: {
          query: {
            measures: [
              "ContainerStatus.dirty_count",
              "ContainerStatus.clean_count"
            ],
            timeDimensions: [],
            order: {
              "ContainerStatus.dirty_count": "desc"
            },
            dimensions: [
              "ContainerStatus.current_status_age"
            ],
            filters: [
              {
                dimension: "ContainerStatus.operated_by",
                operator: "equals",
                values: this.state.facilityList
              }
            ]
          },
          chartType: "bar"
        }
      }    
    ];



    const dashboardItem = item => (
      // <Grid item xs={12} lg={6} key={item.id}>
      //   <DashboardItem title={item.name}>
      //     <ChartRenderer vizState={item.vizState} />
      //   </DashboardItem>
      // </Grid>

      <Col
        span={24}
        lg={12}
        key={item.id}
        style={{
          marginBottom: "24px"
        }}
      >
        <DashboardItem title={item.name}>
          <ChartRenderer vizState={item.vizState} />
        </DashboardItem>
      </Col>


  );
    return DashboardItems.length ? (
      <Dashboard>
        {console.log('this is running')}
        <Grid
          xs={12} lg={7} container spacing={3}
          style={{ padding: 30 }} justify="space-around" alignItems="flex-start"
        >
          <h3>Select Carrier Name </h3> 

          <Multiselect
            options={this.state.options} // Options to display in the dropdown
            selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
            onSelect={this.onSelect} // Function will trigger on select event
            onRemove={this.onRemove} // Function will trigger on remove event
            placeholder = "Select Carrier name"
            displayValue="name" // Property name to display in the dropdown options
            style={this.style}
          />

          <br />
          <br />
          <br />
          <br />

                  </Grid>

        {

          DashboardItems.map(dashboardItem)

        }

      </Dashboard>
    ) : (
        <div
          style={{
            textAlign: "center",
            padding: 12
          }}
        >
          <Typography variant="h5" color="inherit">
            There are no charts on this dashboard. Use Playground Build to add one.
    </Typography>
        </div>
      );



  }
}


export default CustomerDashboardPage;
